import { api } from '../../plugins/api';
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const getDefaultState = () => {
	return {
		declarationsObligatoires: {
			id: '',
			demandeAdmission: '',
			demandeInscription: '',
			pp: '',
			pasDeChangement: false,
			decisionDisciplinaireDUnAutreOrdreProfessionnel: null,
			decisionDisciplinaireDUnOrganismeDeLExterieurDuQuebec: null,
			natureDeLInfraction: "",
			natureDeLaSanction: "",
			dateDecision: null,
			nomOrganisme: "",
			provincePays: "",
			nPermisDeCetOrdre: "",
			pasDeChangementInfraction: false,
			decisionDUnTribunalCanadienOuEtranger: null,
			decisionRendueAuQuebec: null,
			objetDeLAccusation: "",
			pays: "",
			provinceEtat: "",
			districtJudiciaire: "",
			numeroDeDossierDeLaCour: "",
			poursuitePourUneInfractionPunissableDe5AnsOuPlusDEmprisonnement: null,
			pasDeChangementJudiciaire: false,
			objetAccusation: "",
			pays2: "",
			provinceEtat2: "",
			nDossierDeLaCour: "",
			active: true
		}
	}
}


const state = getDefaultState()

const getters = {
	GET_DECLARATIONSOBLIGATOIRES: (state) => { return state.declarationsObligatoires }
}

const mutations = {
	SET_ID (state, id) {
		state.declarationsObligatoires.id = id
	},
	SET_CONTACTID (state, id) {
		state.declarationsObligatoires.pp = id
	},
	SET_DEMANDEADMISSIONID (state, id) {
		state.declarationsObligatoires.demandeAdmission = id
	},
	SET_DECLARATIONSOBLIGATOIRES (state, dto) {
		state.declarationsObligatoires = { ...dto }
	},
	resetState (state) {
		Object.assign(state, getDefaultState())
	}
}

const actions = {
	async getDeclarationsObligatoiresByContactId ({ commit }, contactId) {
		const response = await api.get(`declarationsobligatoires/contacts/` + contactId);
		commit("SET_DECLARATIONSOBLIGATOIRES", response.data && response.data ? response.data : getDefaultState().declarationsObligatoires)
		return response
	},
	async getDeclarationsObligatoiresByDemandeAdmissionId ({ commit }, demandeAdmissionId) {
		const response = await api.get(`declarationsobligatoires/demandesadmissions/` + demandeAdmissionId);
		commit("SET_DECLARATIONSOBLIGATOIRES", response.data && response.data[0] ? response.data[0] : getDefaultState().declarationsObligatoires)
	},
	async getDeclarationsObligatoiresByDemandeInscriptionId ({ commit }, demandeInscriptionId) {
		const response = await api.get(`declarationsobligatoires/demandesinscriptions/` + demandeInscriptionId);
		commit("SET_DECLARATIONSOBLIGATOIRES", response.data && response.data[0] ? response.data[0] : getDefaultState().declarationsObligatoires)
	},
	async createDeclarationsObligatoires ({ commit }, pSASAdmissionsDTO) {
		const response = await api.post(`declarationsobligatoires`, pSASAdmissionsDTO);
		commit('SET_ID', response.data);
	},
	async getLinkedContactEncryptedId ({ commit }, encryptedId) {
		const response = await api.get(`declarationsobligatoires/${encryptedId}/contact`);
		commit('SET_CONTACTID', response.data ? response.data : null);
	},
	async updateDeclarationsObligatoires ({ commit }, pSASAdmissionsDTO) {
		const response = await api.put(`declarationsobligatoires`, pSASAdmissionsDTO);
		commit('SET_DECLARATIONSOBLIGATOIRES', response.data ? response.data : null);
	},
	getDeclarationsObligatoires ({ state }, encryptedId) {
		return api.get(`declarationsobligatoires/` + encryptedId);
	},
	resetModuleState ({ commit }) {
		commit('resetState')
	},
}

export default ({
	namespaced: true,
	state: state,
	mutations: mutations,
	getters: getters,
	actions: actions
})